import { render } from "./ChannelAttribution.vue?vue&type=template&id=26c133da"
import script from "./ChannelAttribution.vue?vue&type=script&lang=js"
export * from "./ChannelAttribution.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__